export const refreshUpsells = () => {
  const miniCartUpsells = document.querySelectorAll('.c-upsell-cart--mini');
  const mainCartUpsells = document.querySelectorAll('.c-upsell-cart--main');

  const cartDrawer = document.querySelector('.c-cart-items__list');
  const mainCart = document.querySelector('.c-cart');

  const miniCartItems = cartDrawer ? cartDrawer.querySelectorAll('.c-cart-item') : [];
  const mainCartItems = mainCart ? mainCart.querySelectorAll('.c-cart-item') : [];

  const miniCartVariantIds = Array.from(miniCartItems, (item) => item.getAttribute('data-product-id'));
  const mainCartVariantIds = Array.from(mainCartItems, (item) => item.getAttribute('data-product-id'));

  const updateUpsellGroup = (upsells, variantIds) => {
    upsells.forEach((upsell) => {
      const cards = Array.from(upsell.querySelectorAll('.c-product-card'));
      cards.forEach((card) => {
        const id = card.getAttribute('data-product-variant-id');
        const addToCartButton = card.querySelector('.c-product-card__add');
        const span = addToCartButton.querySelector('span');
        span.classList.remove('c-product-card__add-loading-spinner');
        if (variantIds.includes(id)) {
          addToCartButton.setAttribute('disabled', true);
          addToCartButton.querySelector('.c-icon-cart').style.display = 'none';
          span.innerHTML = 'Added!';
        } else {
          addToCartButton.removeAttribute('disabled');
          addToCartButton.querySelector('.c-icon-cart').style.display = 'block';
          span.innerHTML = 'Add';
        }
      });
      const allInCart = cards.every((card) => variantIds.includes(card.getAttribute('data-product-variant-id')));
      upsell.classList[allInCart ? 'add' : 'remove']('u-display-none');
    });
  };

  updateUpsellGroup(miniCartUpsells, miniCartVariantIds);
  updateUpsellGroup(mainCartUpsells, mainCartVariantIds);
};

export async function refreshCartCount() {
  try {
    const res = await fetch('/cart.js', { cache: 'no-store' });
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const cart = await res.json();

    const bubble = document.querySelector('#cart-icon-bubble .cart-count-bubble');
    const countEl = bubble?.querySelector('span');

    if (cart.item_count === 0) {
      const emptyCartElement = document.querySelector('.c-cart-items__empty');
      const cartFormElement = document.querySelector('.c-cart-items__container form');
      const orderSummaryElement = document.querySelector('.c-order-summary');
      const upsellElements = document.querySelectorAll('.c-upsell-cart');

      if (emptyCartElement) {
        emptyCartElement.style.display = '';
      }

      if (cartFormElement) {
        cartFormElement.style.display = 'none';
      }

      if (orderSummaryElement) {
        orderSummaryElement.style.display = 'none';
      }

      if (upsellElements.length > 0) {
        upsellElements.forEach((upsell) => {
          if (upsell) {
            upsell.style.display = 'none';
          }
        });
      }
    }

    if (countEl) {
      countEl.textContent = cart.item_count;

      if (cart.item_count === 0) {
        bubble.style.display = 'none';
      } else {
        bubble.style.display = '';
      }
    }
  } catch (err) {
    console.error('refreshCartCount failed:', err);
  }

  return;
}

export async function refreshMiniCart() {
  const currentCartItems = document.querySelectorAll('.c-cart-item');
  const currentCartItemCount = currentCartItems.length;

  const url = new URL(window.Shopify.routes.root, window.location.origin);
  url.searchParams.set('section_id', 'cart-drawer');
  url.searchParams.set('_', Date.now().toString());

  const res = await fetch(url, { cache: 'no-store' });
  if (!res.ok) throw new Error(`Could not refresh cart drawer (status ${res.status})`);

  const text = await res.text();
  const parser = new DOMParser();
  const doc = parser.parseFromString(text, 'text/html');

  const newCartItems = doc.querySelectorAll('.c-cart-item');
  const newCartItemCount = newCartItems.length;

  const newDrawer = doc.querySelector('cart-drawer');
  const currentDrawer = document.querySelector('cart-drawer');

  if ((newCartItemCount === 0 || currentCartItemCount === 0) && newDrawer && currentDrawer) {
    currentDrawer.innerHTML = newDrawer.innerHTML;
    return;
  } else {
    updateCartElements(doc);
    return;
  }
}

function updateCartElements(doc) {
  const newCartItemsContainer = doc.querySelector('cart-drawer-items');
  const currentCartItemsContainers = document.querySelectorAll('cart-drawer-items');
  if (newCartItemsContainer && currentCartItemsContainers.length > 0) {
    currentCartItemsContainers.forEach((container) => {
      container.innerHTML = newCartItemsContainer.innerHTML;
    });
  }

  const isCartPage = window.location.pathname === '/cart';

  if (isCartPage) {
    const newCartSummary = doc.querySelector('.c-cart-summary');
    const currentCartSummaries = document.querySelectorAll('.c-cart-summary');
    if (newCartSummary && currentCartSummaries.length > 0) {
      currentCartSummaries.forEach((summary) => {
        summary.innerHTML = newCartSummary.innerHTML;
      });
    }
  }

  const newTotals = doc.querySelector('.totals');
  const currentTotals = document.querySelectorAll('.totals');
  if (newTotals && currentTotals.length > 0) {
    currentTotals.forEach((total) => {
      total.innerHTML = newTotals.innerHTML;
    });
  }

  const newCheckoutButton = doc.querySelector('#CartDrawer-Checkout');
  const currentCheckoutButtons = document.querySelectorAll('#CartDrawer-Checkout');
  if (newCheckoutButton && currentCheckoutButtons.length > 0) {
    currentCheckoutButtons.forEach((button) => {
      button.innerHTML = newCheckoutButton.innerHTML;

      if (newCheckoutButton.hasAttribute('disabled')) {
        button.setAttribute('disabled', '');
      } else {
        button.removeAttribute('disabled');
      }
    });
  }

  const newCartCheckoutButton = doc.querySelector('button#checkout');
  const currentCartCheckoutButtons = document.querySelectorAll('button#checkout');
  if (newCartCheckoutButton && currentCartCheckoutButtons.length > 0) {
    currentCartCheckoutButtons.forEach((button) => {
      button.innerHTML = newCartCheckoutButton.innerHTML;

      if (newCartCheckoutButton.hasAttribute('disabled')) {
        button.setAttribute('disabled', '');
      } else {
        button.removeAttribute('disabled');
      }
    });
  }

  if (newCheckoutButton) {
    const baseText = (newCheckoutButton.textContent || '').trim();
    if (baseText) {
      const clonedButtons = document.querySelectorAll('[data-route-cloned-button="true"]');
      clonedButtons.forEach((button) => {
        button.textContent = baseText;
      });
    }
  }
}

export async function refreshCart(refreshWholeCart = false) {
  if (refreshWholeCart) {
    const url = new URL(`${window.Shopify.routes.root}cart`, window.location.origin);
    url.searchParams.set('_', Date.now().toString());
    const res = await fetch(url, { cache: 'no-store' });

    if (!res.ok) {
      console.error(`Cart refresh failed (${res.status}): ${res.statusText}`);
      throw new Error(`Could not refresh cart (status ${res.status})`);
    }

    const html = await res.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');

    document.body.innerHTML = doc.body.innerHTML;

    if (doc.title) {
      document.title = doc.title;
    }

    updateCartElements(doc);
    window.history.replaceState({}, '', url.pathname);

    return;
  }

  const wrapper = document.querySelector('#main-cart-items');
  if (!wrapper) {
    return;
  }

  const sectionId = wrapper.dataset.id;
  if (!sectionId) {
    return;
  }

  const url = new URL(`${window.Shopify.routes.root}cart`, window.location.origin);
  url.searchParams.set('section_id', sectionId);
  url.searchParams.set('_', Date.now().toString());
  const res = await fetch(url, { cache: 'no-store' });

  if (!res.ok) {
    console.error(`Cart refresh failed (${res.status}): ${res.statusText}`);
    throw new Error(`Could not refresh cart (status ${res.status})`);
  }

  const html = await res.text();
  const doc = new DOMParser().parseFromString(html, 'text/html');
  const newSection = doc.querySelector(`#${wrapper.id}`);

  if (!newSection) {
    return;
  }

  wrapper.innerHTML = newSection.innerHTML;

  updateCartElements(doc);

  return;
}

export const updateBreadcrumbs = () => {
  const nav = document.querySelector('.c-breadcrumbs');
  if (!nav) return;
  const seen = new Set();
  nav.querySelectorAll('a').forEach((link) => {
    const href = link.getAttribute('href');
    if (seen.has(href)) {
      let prev = link.previousSibling;
      while (prev) {
        if (prev.nodeType === 1 && prev.classList.contains('c-breadcrumbs__separator')) {
          prev.remove();
          break;
        }
        prev = prev.previousSibling;
      }
      link.remove();
    } else {
      seen.add(href);
    }
  });
  nav.classList.remove('c-breadcrumbs--loading');
};

export const showNotification = (msg, isError = false) => {
  let bar = document.getElementById('cart-sync-toast');
  if (!bar) {
    bar = document.createElement('div');
    bar.id = 'cart-sync-toast';
    Object.assign(bar.style, {
      position: 'fixed',
      bottom: '20px',
      left: '50%',
      transform: 'translateX(-50%)',
      padding: '10px 20px',
      background: isError ? 'rgba(230,35,37,0.9)' : 'rgba(79,125,60,0.9)',
      color: '#fff',
      borderRadius: '4px',
      zIndex: 9999,
      fontFamily: 'Eureka, sans-serif',
    });
    document.body.appendChild(bar);
  }
  bar.textContent = msg;
  clearTimeout(bar._timeout);
  bar._timeout = setTimeout(() => bar.remove(), 4500);
};
